import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { PluginState } from './main.ts';

export const conflictResolutionPluginKey: PluginKey<PluginState> = new PluginKey<PluginState>(
	'conflictResolutionPluginKey',
);
